import { z } from 'zod';
import { EventNpsPartialDto } from './event-nps';

/**
 * Статус доступа к групповым фото и обратной связи.
 * `canViewPhotos` = false пока отмеченный пользователь не завершил NPS,
 * если организатор не выключил оценки (`groupPhotoRatingsEnabled`).
 */
export const EventFeedbackStatusDto = z.object({
  eventId: z.uuid(),
  isTaggedOnPhoto: z.boolean(),
  npsCompleted: z.boolean(),
  canViewPhotos: z.boolean(),
  /** false — отмеченные открывают фото без трёх оценок. */
  groupPhotoRatingsEnabled: z.boolean(),
  /** Заполненные оценки, если NPS начат, но не завершён (например, в боте). */
  npsPartial: EventNpsPartialDto.optional(),
});

export const SetGroupPhotoRatingsInput = z.object({
  enabled: z.boolean(),
});

export type SetGroupPhotoRatingsInput = z.infer<typeof SetGroupPhotoRatingsInput>;

export type EventFeedbackStatusDto = z.infer<typeof EventFeedbackStatusDto>;
